import { Api } from "./Api.jsx";

export const postLogin = async ({ nif, password }) => {
  try {
    const response = await Api.post("/login/", { nif, password });
    return response.data;
  } catch (error) {
    console.error("Error login: ", error);
    throw error;
  }
};
